import { createContext } from 'react';

const insights = [];
const layout = [
    {
        width: 200,
        filterType: 'text',
        type: 'text',
        disabledField: false,
        disabledFilter: false,
        textContent: 'Användare',
        filterValue: 'userName',
        textValue: 'user.name',
        linkValue: 'user.link',
    },
    {
        width: 200,
        filterType: 'text',
        type: 'text',
        disabledField: false,
        disabledFilter: false,
        textContent: 'Chef',
        filterValue: 'bossName',
        textValue: 'boss.name',
        linkValue: 'boss.link',
    },
    {
        width: 200,
        filterType: 'text',
        type: 'text',
        disabledField: false,
        disabledFilter: true,
        textContent: 'Bokade möten',
        filterValue: 'BookedMeetings',
        textValue: 'bookedMeetings',
    },
    {
        width: 200,
        filterType: 'text',
        type: 'text',
        disabledField: false,
        disabledFilter: true,
        textContent: 'Genomförda möten',
        filterValue: 'CompletedMeetings',
        textValue: 'completedMeetings',
    },
    {
        width: 200,
        filterType: 'text',
        type: 'text',
        disabledField: false,
        disabledFilter: true,
        textContent: 'Förfrågningar',
        filterValue: 'DealRequests',
        textValue: 'dealRequests',
    },
    {
        width: 200,
        filterType: 'text',
        type: 'text',
        disabledField: false,
        disabledFilter: true,
        textContent: 'Aktiva affärer',
        filterValue: 'WonDeals',
        textValue: 'wonDeals',
    },
    {
        width: 200,
        filterType: 'text',
        type: 'text',
        disabledField: false,
        disabledFilter: true,
        textContent: 'Förlorade affärer',
        filterValue: 'LostDeals',
        textValue: 'lostDeals',
    },
];

export const initialState = {
    apiUrl: 'crmInsightsFront',
    layout: layout,
    insights: insights,
    rows: insights,
    viewSettings: {
        minIndex: 0,
        maxIndex: 0,
        itemHeight: 40,
        totalHeight: 0,
        bufferHeight: 0,
        topPaddingHeight: 0,
        bottomPaddingHeight: 0,
        tolerance: 20,
    },
    requestObject: {
        startIndex: 0,
        amount: 30,
        tolerance: 20,
        filters: {},
    },
};

export const reducer = (state, action) => {
    switch (action.type) {
        case 'UPDATE_VIEW_SETTINGS_AND_REQUEST_OBJECT':
            return {
                ...state,
                viewSettings: action.viewSettings,
                requestObject: action.requestObject,
            };
        case 'UPDATE_VIEW_SETTINGS':
            return {
                ...state,
                viewSettings: action.viewSettings,
            };
        case 'UPDATE_REQUEST_OBJECT':
            return {
                ...state,
                requestObject: action.requestObject,
            };
        case 'UPDATE_DATA':
            return {
                ...state,
                insights: action.payload,
                rows: action.payload,
            };
    }
};

export const DataContext = createContext(initialState);
